
import { BLogoV } from '@/components/svg'
import i18n from '@/i18n'
import Vue from 'vue'
import { Tabs } from './widget'
export default Vue.extend({

    components: { BLogoV, Tabs },
    data() {
        return {
            about: {},
            muted: true,
        }
    },
    async mounted() {
        try {
            const about = await this.$axios.get('/about', {
                params: {
                    fields: '*,translations.*',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale
                }
            })
            console.log(about.data.data.translations[0])
            this.about = about.data.data.translations[0]
        } catch (error) {
            console.error('Error fetching term data:', error)
        }

    },

    metaInfo() {
        return {
            title: "About Us | Bobu Africa",
            link: [
                { rel: "canonical", href: `${window.location.href}` }
            ],
            meta: [
                { name: 'description', content: 'About Bobu Africa' },
                { property: "og:type", content: "website" },
                { property: "og:url", content: `${window.location.href}` },
                { property: "og:title", content: "About Bobu Africa" },
                { property: "og:description", content: "About Bobu Africa" },
                { property: "og:image", content: `${this.$assets}/${this.about.banner}` },

                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:url", content: `${window.location.href}` },
                { property: "twitter:title", content: "About Bobu Africa" },
                { property: "twitter:description", content: "About Bobu Africa" },
                { property: "twitter:image", content: `${this.$assets}/${this.about.banner}` },

            ]
        }
    },
})


